<template>
  <el-dialog
    title="添加退货地址"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form
      :model="addShopReturnAddressInfo"
      :rules="rules"
      ref="addForm"
      label-width="120px"
    >
      <el-form-item label="收货人名称" prop="name">
        <el-input
          v-model="addShopReturnAddressInfo.name"
          placeholder="必填，请填写收货人名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="link">
        <el-input
          v-model="addShopReturnAddressInfo.link"
          placeholder="必填，请填写联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="seq">
        <el-input
          v-model="addShopReturnAddressInfo.seq"
          placeholder="必填，请填写排序"
        ></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input
          type="textarea"
          v-model="addShopReturnAddressInfo.address"
          placeholder="选填，请填写详细地址"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveShopReturnAddressInfo">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { saveShopReturnAddress } from '@/api/goods/shopReturnAddressApi'

export default {
  name: 'AddShopReturnAddress',
  data() {
    return {
      dialogVisible: false,
      addShopReturnAddressInfo: {
        name: '',
        link: '',
        address: '',
        seq: '',
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: '收货人名称不能为空', trigger: 'blur' },
          { max: 64, message: '收货人名称太长', trigger: 'blur' }
        ],
        link: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '联系电话格式错误', trigger: 'blur' }
        ],
        seq: [
          { required: true, message: '排序不能为空', trigger: 'blur' },
          { pattern: /^\d+$/, message: '排序不是有效数字', trigger: 'blur' }
        ],
        address: [
          { max: 512, message: '详细地址太长', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.addShopReturnAddressInfo.shopId = getShopId()
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.addShopReturnAddressInfo = {
        name: '',
        link: '',
        address: '',
        seq: '',
        shopId: ''
      }
    },
    saveShopReturnAddressInfo() {
      this.$refs.addForm.validate(async valid => {
        if (!valid) return
        
        try {
          await saveShopReturnAddress(this.addShopReturnAddressInfo)
          this.$message.success('添加成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('添加退货地址失败:', error)
        }
      })
    }
  }
}
</script>